import { SmartEnum } from '../common/Utility.types';

export const CALCULATION_STATUS = {
    CALC_DISABLED: 'CALC_DISABLED',
    CALC_NEEDS_REFRESH: 'CALC_NEEDS_REFRESH',
    CALC_RES_OK: 'CALC_RES_OK',
    CALC_RES_OK_WITH_WARNINGS: 'CALC_RES_OK_WITH_WARNINGS',
    CALC_RES_OK_WITH_ERRORS: 'CALC_RES_OK_WITH_ERRORS',
    CALC_RES_ERROR: 'CALC_RES_ERROR',
    CALC_RUNNING: 'CALC_RUNNING'
} as const;

export type CalculationStatus = SmartEnum<typeof CALCULATION_STATUS>;

export type DashboardValue = {
    sortNo?: number;
    title: string;
    value: string | number | boolean;
    severityLevel?: SeverityLevel;
};

export type DashboardValues = Readonly<DashboardValue[]>;

export const SEVERITY_LEVEL = { INFORMATION: 1, WARNING: 2, ERROR: 3 };
export type SeverityLevel = SmartEnum<typeof SEVERITY_LEVEL>;

export type CalculationWarning = {
    component: string;
    information: string;
    severityLevel?: SeverityLevel;
};

export type CalculationResult = {
    status?: CalculationStatus;
    resultValues: DashboardValue[];
    warnings: CalculationWarning[];
};
